import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { PudoTransactionReportListResponse, TransactionQueryParams, WarehouseTransactionReportListResponse } from '@frontend/transaction/types';

export class TransactionReportClient extends APIClient {
    public static readonly endpoint = '/transaction-api/v1';

    public static async fetchReportPudoTransactions(
        queryParams?: ApiQueryParams<DefaultQueryParams | TransactionQueryParams>
    ): Promise<PudoTransactionReportListResponse> {
        return await this.apiPaginated<PudoTransactionReportListResponse, DefaultQueryParams | TransactionQueryParams>(
            `${this.endpoint}/report-pudo-transactions`,
            queryParams
        );
    }
    public static async fetchReportWarehouseTransactions(
        queryParams?: ApiQueryParams<DefaultQueryParams | TransactionQueryParams>
    ): Promise<WarehouseTransactionReportListResponse> {
        return await this.apiPaginated<WarehouseTransactionReportListResponse, DefaultQueryParams | TransactionQueryParams>(
            `${this.endpoint}/report-warehouse-transactions`,
            queryParams
        );
    }
}
